// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery } from '@tanstack/react-query';
import { useLoggedInUser } from '../../../contexts/UserProvider';
import { getBlacklistedUsers } from '../../../utils/operationalApi';

const useBlacklistedUsers = () => {
  const { userAccessToken } = useLoggedInUser();

  return useQuery({
    queryKey: ['blacklistedUsers'],
    queryFn: () => getBlacklistedUsers(userAccessToken),
  });
};

export default useBlacklistedUsers;
